// The way in. The mark and the system's name above one calm form — nothing else on the
// page. Before anyone is logged in the theme follows the device (context/ThemeContext).
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import he from '../../i18n/he';
import Button from '../../components/Button';
import { TextInput } from '../../components/Form';
import { LogoMark } from '../../components/Logo';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(false);
    try {
      await login(email, password);
    } catch {
      setError(true);
    }
  };

  return (
    <div className="center-screen login-screen">
      <div className="login-panel">
        <div className="login-brand">
          <LogoMark size={56} />
          <h1>{he.app}</h1>
        </div>
        <form className="card login-form" onSubmit={submit}>
          <TextInput
            label={he.login.email}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <TextInput
            label={he.login.password}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <div className="error-text login-error">{he.login.error}</div>}
          <Button type="submit">{he.login.submit}</Button>
        </form>
      </div>
    </div>
  );
}
